import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import CustomToast from "src/components/CustomToast/CustomToast";
import cmsClient from "src/services/cmsClient";

const editEvent = async ({
	id,
	payload
}: {
	id: number;
	payload: FormData;
}) => {
	const response = await cmsClient.patch<IEvent>(
		`/homepage/admin/events/${id}/`,
		payload
	);

	return response.data;
};

const useEditEvent = () => {
	const queryClient = useQueryClient();

	const onSuccess = () => {
		toast.success(
			<CustomToast type="Success" message="Event updated successfully" />,
			{ hideProgressBar: true }
		);

		queryClient.invalidateQueries(["events"]);
	};

	const onError = () => {
		toast.error(
			<CustomToast type="Error" message="Something went wrong, try again" />,
			{ hideProgressBar: true }
		);
	};

	const mutation = useMutation(editEvent, {
		onError,
		onSuccess
	});

	return mutation;
};

export default useEditEvent;
